"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILED = exports.SUCCEEDED = exports.PENDING = exports.UNINITIALIZED = void 0;
var UNINITIALIZED = 'UNINITIALIZED';
exports.UNINITIALIZED = UNINITIALIZED;
var PENDING = 'PENDING';
exports.PENDING = PENDING;
var SUCCEEDED = 'SUCCEEDED';
exports.SUCCEEDED = SUCCEEDED;
var FAILED = 'FAILED';
exports.FAILED = FAILED;